// @ts-ignore
import React from "react";
import { useState, useEffect, useRef } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import ContainerForLinks from "../../../containerForLinks";
import { Grid, Button, Typography } from "@material-ui/core";
// @ts-ignore
import ArrowRight from "../../../icon/ArrowRight.svg";
// @ts-ignore
import WhiteArrowRight from "../../../icon/WhiteArrowForPink.svg"
// @ts-ignore
import WhiteSpinner from "../../../icon/WhiteSpinner.svg"
// @ts-ignore
import BlackSpinner from "../../../icon/BlackSpinner.svg"


interface customWindow extends Window {
  coursesFindOutMore: any;
}

declare const window: customWindow;




type CampusCTAProps = {
  reference?: {
    _type: string;
    slug: {
      _key?: string;
      _type: string;
      current: string;
    };
    subfolder: {
      folder: string;
    };
  };
  styles?: string;
  linkText: string | JSX.Element;
  alignment?: string;
  buttonType: "rectangular" | "circular";
  pageType?: "regular" | "available courses"; // available course is a full width
  variant?: "small" | "medium" | "large";
  customClickEvent?: () => void;
  arrowIcon: boolean;
  disabled?: boolean;
  newTab: boolean;
  buttonColour?: "orange" | "pink" | "white" | "grey";
  children?: JSX.Element | any;
  slug?: {
    current: string;
  }
  isAuth?: boolean;
  slugNo?: {
    current: string;
  },
  autoHeight: boolean;
  subfolder?:{
    folder: string;
  },
  loading: boolean;
  customBorderRadius: string;
};


const CampusCTA = ({
  reference,
  styles,
  linkText,
  alignment,
  buttonType,
  pageType = "regular", // Default
  variant = "large", // Default
  arrowIcon = buttonType === "rectangular" && true, // Default for rectangular
  customClickEvent,
  disabled = false, // Default
  buttonColour = "pink", // Default
  loading = false,
  children,
  slug,
  newTab,
  isAuth,
  slugNo,
  subfolder,
  autoHeight = false,
  customBorderRadius,
}: CampusCTAProps): React.FC => {



  const getPadding = (variant) => {
    if (variant === "large") {
      return "18px 32px 18px 32px !important";
    } else if (variant === "medium") {
      return "16px 24px 16px 24px !important";
    } else if (variant === "small") {
      return "10px 18px 10px 18px !important";
    }
  };

  const getBorderRadius = (buttonType) => {
    if (buttonType === "rectangular") {
      return 0;
    } else if (buttonType === "circular") {
      return "70px";
    } else {
      return null;
    }
  };

  const getFontSizesRect = (variant) => {
    if (variant === "large") {
      return {
        labelFontSize: "16px",
        labelWeight: 500,
        labelLineHeight: "20px",
      };
    } else if (variant === "medium") {
      return {
        labelFontSize: "14px",
        labelWeight: 500,
        labelLineHeight: "16px",
      };
    } else if (variant === "small") {
      return {
        labelFontSize: "12px",
        labelWeight: 500,
        labelLineHeight: "16px",
      };
    }
  };

  const getFontSizesCircle = (variant) => {
    if (variant === "large") {
      return {
        labelFontSize: "16px",
        labelWeight: 500,
        labelLineHeight: "18px",
      };
    } else if (variant === "medium") {
      return {
        labelFontSize: "14px",
        labelWeight: 500,
        labelLineHeight: "16px",
      };
    } else if (variant === "small") {
      return {
        labelFontSize: "12px",
        labelWeight: 500,
        labelLineHeight: "16px",
      };
    }
  };

  const buttonPadding = getPadding(variant);
  const buttonRadius = getBorderRadius(buttonType);
  const { labelFontSize, labelWeight, labelLineHeight } =
    buttonType === "rectangular"
      ? getFontSizesRect(variant)
      : getFontSizesCircle(variant);

  // const LoadingSpinner = buttonColour === "pink" ? WhiteSpinner : BlackSpinner
  const getSpinner = () => <img className={classes.loadingSpinner} src={buttonColour === "pink" ? WhiteSpinner : BlackSpinner}/>

  var StyledButton = buttonColour === "orange" && withStyles({
    root: {
      padding: buttonPadding,
      backgroundColor: "#FFD574 !important",
      transition: "background 0.3s !important",
      borderRadius: `${buttonRadius} !important`,
      width: pageType === "available courses" ? "100%" : "auto",

      "&:hover": {
        backgroundColor: "#FFE3A2 !important",
      },
      "&:active": {
        backgroundColor: "#F2CA6E !important",
      },
      "&:focus": {
        backgroundColor: "#F2CA6E !important",
        border: "2px solid #FFFFFF !important",
        outline: "2px solid #F2CA6E !important",
        boxShadow:
          "inset 0px -2px 0px #F2CA6E, inset -2px 0px 0px #F2CA6E, inset 0px 2px 0px #F2CA6E, inset 2px 0px 0px #F2CA6E !important",
        "&:before": {
          border: "2px solid #F2CA6E !important",
        },
      },
      "&:disabled": {
        background: "#EAEAEF",
        border: "1px solid #DCDCE4",
      },
    },
    label: {
      "& span": {
        fontSize: `${labelFontSize} !important`,
        fontWeight: `${labelWeight} !important` as any,
        lineHeight: `${labelLineHeight} !important`,
        textTransform: "uppercase",
        color: "#3C465F",
      },
    },
  })(Button) || buttonColour === "pink" && withStyles({
    root: {
      padding: buttonPadding,
      backgroundColor: "#FF0F5F !important",
      transition: "background 0.3s !important",
      borderRadius: customBorderRadius ? `${customBorderRadius} !important` : `${buttonRadius} !important`,
      width: pageType === "available courses" ? "100%" : "auto",

      "&:hover": {
        backgroundColor: "#FF3377 !important",
      },
      "&:active": {
        backgroundColor: "#FF3377 !important",
      },
      "&:focus-visible": {
        backgroundColor: "#FF0F5F!important",
        border: "2px solid #FFFFFF !important",
        outline: "2px solid #FF0F5F !important",
        boxShadow: "inset 0px -2px 0px #FF0F5F, inset -2px 0px 0px #FF0F5F, inset 0px 2px 0px #FF0F5F, inset 2px 0px 0px #FF0F5F",
        "&:before": {
          border: "2px solid #FF0F5F !important",
        },
      },
      "&:disabled": {
        background: "#EAEAEF",
        border: "1px solid #DCDCE4",
      },
    },
    label: {
      "& span": {
        fontSize: `${labelFontSize} !important`,
        fontWeight: `${labelWeight} !important` as any,
        lineHeight: `${labelLineHeight} !important`,
        textTransform: "uppercase",
        color: "#FFFFFF !important",
      },
    },
  })(Button) || buttonColour === "grey" && withStyles((theme) => ({
    root: {
      padding: buttonPadding,
      backgroundColor: "#FFFFFF",
      transition: "background 0.3s !important",
      borderRadius: `${buttonRadius} !important`,
      width: slug && slug.current === "login" ? "100% !important" : pageType === "available courses" ? "100%" : "auto",
      border: '1px solid #3C465F',
      boxSizing: "border-box",
      height: slug && slug.current === "login" ? "48px" : "auto",
      "&:hover": {
        backgroundColor: "#3C465F",
        "& span":{
          color: "#FFFFFF",
        }
      },
      "&:active": {
        backgroundColor: "#3C465F !important",
      },
      "&:focus-visible": {
        backgroundColor: "#FFFFFF!important",
        boxShadow: "inset 0px -2px 0px #3C465F, inset -2px 0px 0px #3C465F, inset 0px 2px 0px #3C465F, inset 2px 0px 0px #3C465F",
        "& span":{
          color: "#3C465F !important",
        }
      },
      "&:disabled": {
        background: "#EAEAEF",
        border: "1px solid #3C465F",
      },

      [theme.breakpoints.down(1945)]: {
        width: '75%'
      },
      [theme.breakpoints.down(1300)]: {
        width: '80%'
      },

      [theme.breakpoints.down(1200)]: {
        width: '88%'
      },
      [theme.breakpoints.down(1101)]: {
        width: '92%'
      },
      [theme.breakpoints.down(1050)]: {
        width: '100%'
      }



    },
    label: {
      "& span": {
        fontSize: `${labelFontSize} !important`,
        fontWeight: `${labelWeight} !important` as any,
        lineHeight: `${labelLineHeight} !important`,
        textTransform: "uppercase",
        color: "#3C465F",
      },
    },
  }))(Button);



  function brazeLogged() {


    window.coursesFindOutMore(slugNo.current, isAuth)


  }

  var auth = isAuth;
  if (typeof isAuth == "undefined") {

    if (typeof window !== 'undefined') {
      auth = (window.localStorage.getItem("isUserAuthenticated") == "true");
    }
    else {
      auth = false;
    }

  }

  const useStyles = makeStyles((theme) => ({
    buttonMargin: {
      paddingTop: "25px",
      paddingBottom: "25px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    buttonNoMargin: {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    buttonGeneral: {},
    buttonCircular: {
      background: "#FFD574",
      borderRadius: "61px",
      height: autoHeight ? "auto" : "54px",
      padding: "18px 24px 18px 24px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        height: autoHeight ? "auto" : "62px",
      },
    },
    buttonText: {
      textTransform: "uppercase",
      color: "#3C465F",
      fontSize: "inherit",
      fontWeight: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit",
    },
    buttonRect: {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    courseButtonText: {
      color: "#3C465F",
      textTransform: "uppercase",
    },
    courseButtonTextWhite: {
      color: "#3C465F",
    },
    buttonImage: {
      marginLeft: ".8em",
      height: "1em",
    },
    visibleAnchor: {
      textDecoration: 'none'
    },
    loadingSpinner:{
      marginLeft: "8px",
      animation: "$spin 5s linear infinite",
      height: labelLineHeight,
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(-360deg)"
      },
      "100%": {
        transform: "rotate(0deg)"
      }
    }
  }));
  const classes = useStyles();


  if (slug && slug.current) {
    return (
      <Grid
        className={
          alignment
            ? alignment === "Text Left"
              ? classes.buttonNoMargin
              : classes.buttonMargin
            : null
        }
      >

          <a className={classes.visibleAnchor} href={ subfolder && subfolder.folder !== "/" ? `${subfolder.folder + slug.current}` : `/${slug.current}`}>

            <StyledButton
              className={
                buttonType === "rectangular"
                  ? `${classes.buttonRect}`
                  : `${classes.buttonCircular}`
              }

            >
              <Typography
                variant="button"
                className={
                  classes.buttonText
                }
              >
                {linkText}
                {children}
              </Typography>
              {!arrowIcon && loading &&
                // <img className={classes.loadingSpinner} src={LoadingSpinner}/>
                getSpinner()
              }
              {arrowIcon && <img
                alt={"arrow"}
                src={ArrowRight}
                className={classes.buttonImage}
              />
              }
            </StyledButton>
          </a>


      </Grid>
    )
  }

  //for the course links when not logged in
  if (slugNo && slugNo.current) {
    return (
      <Grid
        className={
          alignment
            ? alignment === "Text Left"
              ? classes.buttonNoMargin
              : classes.buttonMargin
            : null
        }
      >
          <StyledButton
            className={
              buttonType === "rectangular"
                ? `${classes.buttonRect}`
                : `${classes.buttonCircular}`
            }
          onClick={() => brazeLogged(slugNo.current)}
          >
            <Typography
              variant="button"
              className={
                classes.buttonText
              }
            >
              {linkText}
              {children}
            </Typography>
            {!arrowIcon && loading &&
              // <img className={classes.loadingSpinner} src={LoadingSpinner}/>
              getSpinner()
            }
            {arrowIcon && <img
              alt={"arrow"}
              src={ArrowRight}
              className={classes.buttonImage}
            />
            }
          </StyledButton>
      </Grid>
    )
  }


  if (customClickEvent && !reference){
    return (
      <Grid
        className={
          alignment
            ? alignment === "Text Left"
              ? classes.buttonNoMargin
              : classes.buttonMargin
            : null
        }>
            <StyledButton
              disabled={disabled}
              className={
                buttonType === "rectangular"
                  ? `${classes.buttonRect}`
                  : `${classes.buttonCircular}`
              }
              onClick={() => customClickEvent()}
            >
              <Typography
                variant="button"
                className={
                  classes.buttonText
                }
              >
                {linkText}
              </Typography>
              {!arrowIcon && loading &&
               // <img className={classes.loadingSpinner} src={LoadingSpinner}/>
                getSpinner()
              }
              {arrowIcon &&
                <img
                alt={"arrow"}
                src={ArrowRight}
                className={classes.buttonImage}
                />
              }
            </StyledButton>
      </Grid>
    )
  }

  return (
    <Grid
      className={
        alignment
          ? alignment === "Text Left"
            ? classes.buttonNoMargin
            : classes.buttonMargin
          : null
      }
    >
      {reference?._type === "widgetCategory"  ? (
        <ContainerForLinks
          reference={reference}
          _type="widgetCategory"
          customClassName={undefined}
          logCtaWidgetGoogleAnalyticsEvent={true}
          newTab={newTab}
          onClickHandler={customClickEvent}
          queryParams={undefined}
          isMenuItem={undefined}
          logSidebarLinkGoogleAnalyticsEvent={undefined}
        >
          <StyledButton
            className={
              buttonType === "rectangular"
                ? `${classes.buttonRect}`
                : `${classes.buttonCircular}`
            }
          >
            <Typography variant="button" className={classes.buttonText}>
              {linkText}
            </Typography>
            {!arrowIcon && loading &&
              getSpinner()
            }
          </StyledButton>
        </ContainerForLinks>
      ) : (
        <ContainerForLinks
            reference={reference}
            _type={reference?._type}
            customClassName={undefined}
            logCtaWidgetGoogleAnalyticsEvent={undefined}
            newTab={newTab}
            onClickHandler={customClickEvent}
            queryParams={undefined}
            isMenuItem={undefined}
            logSidebarLinkGoogleAnalyticsEvent={undefined}
        >
          <StyledButton
            className={
              buttonType === "rectangular"
                ? `${classes.buttonRect}`
                : `${classes.buttonCircular}`
            }
          >
            <Typography
              variant="button"
              className={
                  classes.buttonText
              }
            >
              {linkText}
              {children}
            </Typography>
            {!arrowIcon && loading &&
              // <img className={classes.loadingSpinner} src={LoadingSpinner}/>
              getSpinner()
            }
            {arrowIcon && <img
              alt={"arrow"}
              src={ArrowRight}
              className={classes.buttonImage}
            />
            }
          </StyledButton>
        </ContainerForLinks>
      )}
    </Grid>
  );
};

export default CampusCTA;
